import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";

export default function ReserveSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const noDeposit = params.get("noDeposit");
  const [status, setStatus] = useState(noDeposit ? "no_deposit" : "checking");

  useEffect(() => {
    if (!sessionId) return;
    let attempts = 0;
    let cancelled = false;
    const poll = async () => {
      if (cancelled || attempts >= 8) {
        if (!cancelled && status === "checking") setStatus("timeout");
        return;
      }
      try {
        const r = await api.get(`/checkout/status/${sessionId}`);
        if (r.data.payment_status === "paid") { setStatus("paid"); return; }
        if (r.data.status === "expired") { setStatus("expired"); return; }
      } catch (err) {
        console.error("Reservation status check failed:", err);
      }
      attempts++;
      setTimeout(poll, 2000);
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId]);

  const messages = {
    checking: { t: "Verifying payment…", d: "Hang tight, we're confirming your deposit with Stripe." },
    paid: { t: "Reservation confirmed!", d: "Your $50 deposit was received. We've reserved your rabbit and will email you within 24 hours with pickup details." },
    no_deposit: { t: "Reservation request received!", d: "We have your inquiry. We'll reach out within 1–2 days to discuss next steps." },
    expired: { t: "Checkout session expired.", d: "Your reservation request was saved, but the payment session timed out. We'll contact you to retry." },
    timeout: { t: "Still processing…", d: "Payment confirmation is taking longer than usual. Please check your email or contact us." },
  };
  const m = messages[status] || messages.checking;

  return (
    <div className="mx-auto max-w-3xl px-6 py-32 lg:px-12" data-testid="page-reserve-success">
      <div className="border border-border bg-white p-12 text-center">
        <div className="section-label">Status</div>
        <h1 className="mt-4 font-serif text-5xl tracking-tight text-terracotta">{m.t}</h1>
        <p className="mt-6 text-base text-stone">{m.d}</p>
        <div className="mt-10 flex flex-wrap justify-center gap-3">
          <Link to="/rabbits" className="rounded-full bg-bark px-7 py-3.5 text-sm text-cream" data-testid="success-back-rabbits">Back to herd</Link>
          <Link to="/" className="rounded-full border border-bark px-7 py-3.5 text-sm text-bark hover:bg-bark hover:text-cream" data-testid="success-home">Home</Link>
        </div>
      </div>
    </div>
  );
}
